import { CommonModule } from '@angular/common';
// Services
import { PageToastMessagesService } from 'NewAngular/features/components/toast-messages/page-toast-messages-service';
// Modules
import { IconModule } from '../../directives/icon/icon.module';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/features/components/toast-messages/page-toast-messages-service";
import * as i2 from "@angular/common";
import * as i3 from "../../directives/icon/icon.directive";
const _forTrack0 = ($index, $item) => $item.id;
function PageToastMessagesComponent_ul_0_For_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 1);
    i0.ɵɵelement(1, "div", 2)(2, "div", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵlistener("click", function PageToastMessagesComponent_ul_0_For_2_Template_div_click_3_listener() { const message_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.toastMessageService.removeMessage(message_r2.id)); });
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const message_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", message_r2.css);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", message_r2.innerHtml, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("name", "icon-close");
} }
function PageToastMessagesComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵrepeaterCreate(1, PageToastMessagesComponent_ul_0_For_2_Template, 6, 3, "li", 1, _forTrack0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r2.containerStyle);
    i0.ɵɵclassMap(ctx_r2.containerClass);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.toastMessageService.messages);
} }
/**
 * Component that shows toast messages.
 * - One or more toast messages can be shown at a time.
 * - Defaults to stacking messages above each other in a vertical column.
 * - Defaults to showing messages in bottom left corner of page.
 */
export class PageToastMessagesComponent {
    constructor(toastMessageService) {
        this.toastMessageService = toastMessageService;
        // The class attribute of the container that holds toast messages.
        this.containerClass = 'toast toast-bottom-left flex-column';
        /**
         * The style attribute of the container that holds toast messages.
         * To customize where toast messages show, prefer setting the container style to `position: relative`, then wrapping
         * this component in a positioned element.
         *
         * Ex:
         * <div style='...'>
         *  <ycn-toast-messages [containerStyle]='position: relative; z-index: 2000'></ycn-toast-messages>
         * </div>
         */
        this.containerStyle = 'position: fixed; z-index: 2000';
    }
}
PageToastMessagesComponent.ɵfac = function PageToastMessagesComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PageToastMessagesComponent)(i0.ɵɵdirectiveInject(i1.PageToastMessagesService)); };
PageToastMessagesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PageToastMessagesComponent, selectors: [["ycn-page-toast-messages"]], inputs: { containerClass: "containerClass", containerStyle: "containerStyle" }, decls: 1, vars: 1, consts: [[3, "class", "style", 4, "ngIf"], [1, "ml-auto", "mr-auto", "toast", "toast-context", "width-240", 3, "ngClass"], [1, "toast-text", "width-full", 3, "innerHTML"], [1, "divider-vertical", "ml-10"], ["data-test-id", "toast-close", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"], ["role", "img", "ycnIcon", "", 1, "icon-close", 3, "name"]], template: function PageToastMessagesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PageToastMessagesComponent_ul_0_Template, 3, 4, "ul", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.toastMessageService.messages.length > 0);
    } }, dependencies: [CommonModule, i2.NgClass, i2.NgIf, IconModule, i3.IconDirective], encapsulation: 2 });
